<div>
   <div class="row terminals">
      <dx-select-box [items]="this.model.terminals" [value]="this.model.selectedTerminal" displayExpr="displayName"
         placeholder="Terminal"
         [showClearButton]="true"
         (valueChange)="this.model.onTerminalChange($event)"></dx-select-box>
   </div>

   <div class="row portfolio">
      <dx-select-box [items]="this.model.portfolios" [value]="this.model.selectedPortfolio" displayExpr="portfolioName"
         placeholder="Portfolio"
         [showClearButton]="true"
         (valueChange)="this.model.onPortfolioChange($event)"></dx-select-box>
   </div>
   
   <div class="row combo">
      <dx-select-box [items]="this.model.combos" [value]="this.model.selectedCombo" displayExpr="comboName"
         placeholder="Combo"
         [showClearButton]="true"
         (valueChange)="this.model.onComboChange($event)"></dx-select-box>
   </div>
   
   <div class="row group">
      <dx-select-box [items]="this.model.comboGroups" [value]="this.model.selectedComboGroup" displayExpr="comboGroupName"
         [showClearButton]="true"
         placeholder="Combo Group"></dx-select-box>
   </div>
</div>